import { upperFirst } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { shortVisitCode, visitKind } from './helpers';
import styles from './VisitCode.module.scss';

export const VisitCodeBadge = ({ code, visitType, size = 'md' }) => {
  const kind = visitKind(code, visitType);
  if (!code) {
    return <span className={`${styles.dot} ${styles[kind]}`} aria-hidden="true" />;
  }
  return (
    <span
      role="img"
      aria-label={`Code ${code}`}
      title={`${code} · ${visitType}`}
      className={`${styles.badge} ${styles[`kind${upperFirst(kind)}`]} ${styles[`size${upperFirst(size)}`]}`}
    >
      {shortVisitCode(code)}
    </span>
  );
};

export const VisitCodeCorner = ({ code, visitType, size = 'card' }) => {
  if (!code) return null;
  const kind = visitKind(code, visitType);
  return (
    <span
      role="img"
      aria-label={`Code ${code}`}
      title={`${code} · ${visitType}`}
      className={`${styles.badge} ${styles[`kind${upperFirst(kind)}`]} ${styles.corner} ${styles[`corner${upperFirst(size)}`]}`}
    >
      {shortVisitCode(code)}
    </span>
  );
};

const props = {
  code: PropTypes.string,
  visitType: PropTypes.string,
};

VisitCodeBadge.propTypes = { ...props, size: PropTypes.oneOf(['sm', 'md', 'lg']) };
VisitCodeCorner.propTypes = { ...props, size: PropTypes.oneOf(['card', 'panel']) };
